export interface RCP {
    Libelle: string,
    Etablissement: string,
    Departement: string,
    Groupement3C: string,
    RegionAnatomique: string,
    Coordonnateur: string | undefined,
    EmailCoordonnateur: string | undefined,
    Secretaire: string | undefined,
    TelSecretariat: string | undefined,
    EmailSecretariat: string | undefined,
    
}

export const getRCPList = (RCPJson) : Array<RCP> => {
    const rcpList = new Array<RCP>();
    RCPJson.forEach(rcp => {
        const rcpItem : RCP = {
            Libelle: rcp["Libellé RCP"],
            Etablissement: rcp["Etablissement de rattachement"],
            Departement: rcp["Département"],
            Groupement3C: rcp["Groupement 3C"],
            RegionAnatomique: rcp["Region Anatomique"],
            Coordonnateur: rcp["Coordonnateur de la RCP"],
            EmailCoordonnateur: rcp["Email Coordonnateur RCP"],
            Secretaire: rcp["Secrétaire RCP"],
            TelSecretariat: rcp["Tél. Secrétariat RCP"],
            EmailSecretariat: rcp["Email Secrétariat RCP"],
        }
        rcpList.push(rcpItem)
    });
    return rcpList;
}
